var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconSecure = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M11.25 14.049C10.8015 13.7895 10.5 13.305 10.5 12.75C10.5 11.922 11.172 11.25 12 11.25C12.828 11.25 13.5 11.922 13.5 12.75C13.5 13.305 13.1985 13.7895 12.75 14.049V15.75C12.75 16.164 12.414 16.5 12 16.5C11.586 16.5 11.25 16.164 11.25 15.75V14.049Z", fill: "black" }),
            React.createElement("path", { d: "M15.75 6V8.25H16.5C17.7218 8.25 18.75 9.15 18.75 10.3125V18.1875C18.75 19.35 17.7218 20.25 16.5 20.25H7.5C6.27825 20.25 5.25 19.35 5.25 18.1875V10.3125C5.25 9.15 6.27825 8.25 7.5 8.25H8.25V6C8.25 3.92925 9.92925 2.25 12 2.25C14.0708 2.25 15.75 3.92925 15.75 6ZM14.25 6C14.25 4.75725 13.2428 3.75 12 3.75C10.7572 3.75 9.75 4.75725 9.75 6V8.25H14.25V6ZM7.5 9.75C7.06575 9.75 6.75 10.026 6.75 10.3125V18.1875C6.75 18.474 7.06575 18.75 7.5 18.75H16.5C16.9342 18.75 17.25 18.474 17.25 18.1875V10.3125C17.25 10.026 16.9342 9.75 16.5 9.75H7.5Z", fill: "black" }))),
        alt: 'Secure',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconSecure;
//# sourceMappingURL=index.js.map